<template>
  <div>
    <load-profile />
    <!-- Search Container Card -->
    <n-search-container
      v-if="searchFields.length"
      :active="true"
      :show-header="false"
      @search="search"
      @reset="reset"
    >
      <n-search-input
        ref="search"
        v-model="params"
        :fields="searchFields"
      />
    </n-search-container>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-0-5">
        <b-row>
          <b-col>
            <label>{{ $t("general.entries") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </b-col>
          <b-col
            v-if="$can('create', 'video-live-upload')"
            class="text-right"
          >
            <b-button
              variant="primary"
              :to="{ name: 'create-match-video' }"
            >{{ $t("button.create") }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div>
        <n-table
          :fields="fields"
          :items="items"
          :busy="loading"
          :current-page="params.page"
          :per-page="$store.state.pagination.perPage"
          :total="total"
          @sort-changed="sortChanged"
        >
          <template #cell(result)="{ item }">
            <span
              :class="`text-${getFightResultById(item.result)}`"
              class="text-capitalize"
            >
              {{ getFightResultById(item.result) }}
            </span>
          </template>
          <template #cell(videoUrl)="{ item }">
            <a
              :href="item.videoUrl"
              target="_blank"
              class="link-underline"
            >
              Play
            </a>
          </template>
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.isEnable"
              pill
              variant="success"
              badge-glow
            >
              {{ $t(`status.active`) }}
            </b-badge>
            <b-badge
              v-else
              pill
              variant="danger"
              badge-glow
            >
              {{ $t(`status.inactive`) }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                v-if="$can('update', 'video-live-upload')"
                v-b-tooltip.hover
                :to="{
                  name: 'update-match-video',
                  params: { id: data.item.id },
                }"
                :title="$t('general.update')"
                variant="primary"
                pill
                size="sm"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </template>
        </n-table>
        <n-pagination
          class="mt-2"
          :total="total"
          :per-page="$store.state.pagination.perPage"
          :page="params.page"
          @change="list"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BAvatar,
  BBadge, BFormRadio,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Repository from '@/repositories/RepositoryFactory'
import NPagination from '@/components/NPagination.vue'
import NSearchContainer from '@/components/NSearchContainer.vue'
import NSearchInput from '@/components/NSearchInput.vue'
import NTable from '@/components/NTable.vue'
import { avatarText } from '@core/utils/filter'
import TableFields from './tableFields'
import SearchInputs from './searchInput'

const MatchVideoRepository = Repository.get('matchVideo')

export default {
  components: {
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BButton,
    BAvatar,
    NPagination,
    NSearchContainer,
    NSearchInput,
    NTable,
    vSelect,
    BBadge,
  },
  data() {
    return {
      items: [],
      loading: false,
      total: 0,
      perPageOptions: this.$store.state.pagination.perPageOptions,
      params: {
        page: Number(this.$route.query.page) || 1,
        order: this.$route.query.order || null,
        sort: this.$route.query.sort || null,
        name: this.$route.query.name || null,
        phone: this.$route.query.phone || null,
        username: this.$route.query.username || null,
        isEnable: this.$route.query.isEnable || null,
      },
      avatarText,
    }
  },
  computed: {
    perPage: {
      get() {
        return this.$store.state.pagination.perPage
      },
      set(value) {
        this.$store.commit('pagination/SET_PER_PAGE', value)
      },
    },
    activeSearch() {
      return (
        !!this.$route.query.name
        || !!this.$route.query.email
        || !!this.$route.query.phone
        || !!this.$route.query.isEnable
        || !!this.$route.query.username
      )
    },
  },
  watch: {
    perPage() {
      this.list(1)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getFightResultById(id) {
      if (id === 1) {
        return 'meron'
      } if (id === 2) {
        return 'wala'
      } if (id === 3) {
        return 'draw'
      } if (id === 4) {
        return 'cancel'
      }

      return ''
    },
    updateQuerySting() {
      this.$router.replace({ query: this.params })
    },
    list(page = 1) {
      this.params.page = page
      this.updateQuerySting()
      this.getData()
    },
    sortChanged(sortBy, sortDirection) {
      this.params.order = sortBy
      this.params.sort = sortDirection
      this.updateQuerySting()
      this.getData()
    },
    search() {
      this.params.page = 1
      this.updateQuerySting()
      this.getData()
    },
    reset() {
      this.$refs.search.reset()
      this.params.page = 1
      this.updateQuerySting()
      this.getData()
    },
    getData() {
      this.loading = true
      const params = {
        ...this.params,
        searchFields: this.searchFields,
      }
      MatchVideoRepository.index(params).then(response => {
        const { data } = response.data
        this.items = [...data.list]
        this.total = data.total
        this.loading = false
      })
        .catch(() => {
          this.loading = false
        })
    },
  },
  setup() {
    const fields = TableFields
    const searchFields = SearchInputs
    return {
      fields,
      searchFields,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
